'use strict';

const startFromFilter = [function() {
  return function(input, start) {
    if(input === undefined || input === null
      || input.length === 0 || typeof input.slice !== 'function') {
      return [];
    }
    start = +start; //parse to int
    return input.slice(start);
  };
}];
export default startFromFilter;
